import axios from "./axios_interceptor";
import { get_jwt_token, loginRedirect } from "./helper_funtions";

export const listUsers = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/user/?page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const getUserDetails = async (id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/user/?id=${id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const getUserDetailsByName = async (username) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/user/?user_name=${username}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const addUsersData = async (args) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/user/`;
    const response = await axios.post(url, args, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};
export const addApiUsersData = async (args) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/api-user/`;
    const response = await axios.post(url, args, config);
    console.log(response.data, "response.data for create api user");
    return { data: response.data, error: null };
    
  } catch (e) {
    return { data: null, error: e.response.data.errors };
  }
};

export const updateUserDetails = async (args) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/user/`;
    const response = await axios.put(url, args, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const deleteUser = async ({ ids }) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        ids: ids,
      },
    };
    const url = `/users/user/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const updateUserPassword = async (args) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/password/`;
    const response = await axios.put(url, args, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const reset2Fa = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/reset-2fa/`;
    const response = await axios.put(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const bulkUploadUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/uploadData/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const getUsersCsv = async () => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/exportcsv/`;
    const response = await axios.get(url, config);
    return { data: response, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const EntityCounts = async (id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/count/?userid=${id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};
export const forgotPassword = async (data) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const url = `/users/forgot-password/`;
    const response = await axios.post(url, data, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const resetPassword = async (data) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const url = `/users/reset-password/?reset_token=${data.reset_token}`;
    const args = {
      password: data.password,
      confirm_password: data.confirmPassword,
    };
    const response = await axios.post(url, args, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const getUserProfile = async (id) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/usersprofile/?id=${id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const updateUsersProfile = async (args) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/usersprofile/`;
    const response = await axios.put(url, args, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const getAuthenticatedUserProfile = async () => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/users/profile/`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const updateUserPreferences = async (preferences) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/preferences/`;
    const response = await axios.put(url, { user_preferences: preferences }, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const activeDevice = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `/users/active-sessions/?user_id=${data.user_id}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const terminateDevices = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        session_keys: data.session_keys,
      },
    };
    const url = `/users/active-sessions/`;
    const response = await axios.delete(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const notAllocatedUserAppsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const allocateAppsToUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = {
      app_ids: data.ids,
      user_id: data.user_id,
      allocation_from: data.allocation_from,
      allocation_till: data.allocation_till,
      policy: data.policy,
      systemuser: data.systemuser,
      allocation_type: data.allocation_type,
      start_time: data.start_time,
      end_time: data.end_time,
      allowed_days: data.allowed_days,
      timezone: data.timezone
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.post(url, body, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const notAllocatedUserAssetsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const allocateAssetsToUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = {
      asset_ids: data.ids,
      user_id: data.user_id,
      systemuser: data.systemuser,
      policy: data.policy,
      allocation_from: data.allocation_from,
      allocation_till: data.allocation_till,
      allocation_type: data.allocation_type,
      start_time: data.start_time,
      end_time: data.end_time,
      allowed_days: data.allowed_days,
      timezone: data.timezone
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.post(url, body, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const AllocatedUserAppsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const DeallocateAppsFromUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        app_ids: data.ids,
        user_id: data.user_id,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.delete(url, config, data);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const AllocatedUserAssetsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const DeallocateAssetsFromUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        asset_ids: data.ids,
        user_id: data.user_id,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.delete(url, config, data);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const AllocatedUserGroupsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const DeallocateGroupsFromUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_ids: data.ids,
        user_id: data.user_id,
      },
    };
    const url = `/users/allocated-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.delete(url, config, data);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const notAllocatedUserGroupsList = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${encodeURIComponent(data.search)}&filter_by=${data.filter_by}`;
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const allocateGroupsToUser = async (data) => {
  try {
    const token = get_jwt_token();
    loginRedirect(token);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = {
      group_ids: data.ids,
      user_id: data.user_id,
    };
    const url = `/users/allocate-resource/?user_id=${data.user_id}&type=${data.type}&page=${data.page}&page_size=${data.page_size}&search=${data.search}&filter_by=${data.filter_by}`;
    const response = await axios.post(url, body, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || 'An error occurred' };
  }
};

export const userPasswordChange = async (formField) => {
  const token = get_jwt_token();
  try {
    loginRedirect(token);
    const response = await axios({
      method: "PUT",
      url: "/users/adminpassword/",
      data: formField,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response };
  }
};


